import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-text',
  templateUrl: './content-text.component.html',
  styleUrls: ['./content-text.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ContentTextComponent {

  @Input() protected content: string;
  @Input() protected contentType: string;
}
